export const bookingSummaryApiQueryKeys = {
  summary: (orgSlug: string, token: string) =>
    ['bookingSummary', orgSlug, token] as const,
};
